<fui-modal (close)="closeModal()" [state]="isOpen">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="closeModal()" >
        </fui-modal-window-toolbar>
        <fui-modal-window-header>
            <fui-breadcrumbs>
                <fui-breadcrumb *ngFor="let view of views; let last = last" [title]="view.context.title$ | async"
                                [showClose]="last" (removed$)="requestCancel()"></fui-breadcrumb>
            </fui-breadcrumbs>
        </fui-modal-window-header>
        <fui-modal-window-main>
            <ng-template #modalwindowmain></ng-template>
        </fui-modal-window-main>
    </fui-modal-window>
</fui-modal>
